import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

const Section4 = ({ data }) => {
  const location =useLocation()
  const firstPath = location.pathname.split("/")[2];

  return (
    <div className="2xl:container md:px-20 px-6 pt-10 pb-20">
      <div className={`w-full flex flex-col p-6 md:p-[54px]  rounded-[24px] ${firstPath=="Aboutus"?"bg-white shadow-services border-journyborder border-[1px]":"bg-Darkblue"}`}>
        <div className="flex flex-col gap-4 text-left pb-6 md:pb-[56px] md:border-b-[1px] border-journyborder">
          <h4 className={`text-18 sm:text-24 md:text-32  font-semibold ${firstPath=="Aboutus"?"text-primarycolor":"text-white"}`}>{data.title}</h4>
          <p className={`text-14 sm:text-16  font-regular ${firstPath=="Aboutus"?"text-secondaryblack":"text-lightwhite"}`}>{data.desc}</p>

        </div>
        <div className=" md:pt-[56px] flex flex-col gap-8 ">
          <h4 className={`text-18 sm:text-24 md:text-32  font-semibold ${firstPath=="Aboutus"?"text-primarycolor":"text-white"}`}>{data.features.title}</h4>

          <div className="grid grid-cols-1 md:grid-cols-4 lg:grid-cols-6 gap-4">
            {data.features.list.map((item, i) => {
              const totalItems = data.features.list.length;
              const itemsPerRowMD = 2;
              const itemsPerRowLG = 3;

              const isLastRowMD = totalItems % itemsPerRowMD !== 0 && i >= totalItems - (totalItems % itemsPerRowMD);
              const isLastRowLG = totalItems % itemsPerRowLG !== 0 && i >= totalItems - (totalItems % itemsPerRowLG);

              // Default span for full row
              let spanClass = "md:col-span-2 lg:col-span-2";

              // If 2 items in last row
              if (isLastRowMD && totalItems % itemsPerRowMD === 2) {
                spanClass = "md:col-span-2"; // 2 items evenly split at md
              } else if (isLastRowMD && totalItems % itemsPerRowMD === 1) {
                spanClass = "md:col-span-4"; // full span at md
              }

              if (isLastRowLG && totalItems % itemsPerRowLG === 2) {
                spanClass += " lg:col-span-3"; // half at lg
              } else if (isLastRowLG && totalItems % itemsPerRowLG === 1) {
                spanClass += " lg:col-span-6"; // full span at lg
              }

              return (
                <div
                  key={i}
                  className={`p-6 rounded-[16px]  flex flex-col gap-4 ${spanClass} ${firstPath=="Aboutus"?"bg-grey":"bg-primaryLight"}`}
                >
                  {
                  item.heading && <h4 className={`font-medium text-18 sm:text-20 ${firstPath=="Aboutus"?"text-primarycolor":"text-white"} `}>
                    {item.heading}
                  </h4>
                  }
                  <div className="flex gap-4 items-start">
                 {firstPath=="Aboutus" && <img className="w-[30px] h-[30px]" src={process.env.PUBLIC_URL + "/images/Aboutus/arrow.svg"} alt="icon" />}

                  <p className={`text-14 font-regular sm:text-16 text-lightwhite ${firstPath=="Aboutus"?"text-secondaryblack":"text-white"}`}>
                    {item.desc}
                  </p>
                  </div>
                </div>
              );
            })}
          </div>




        </div>
      </div>
    </div>
  );
};

export default Section4;
